var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApparel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.6 37.7L63.5 102.5 26.3 132.9c-6.8 5.6-7.8 15.7-2.3 22.5l60.8 74.3c5.6 6.8 15.7 7.8 22.5 2.3l37.2-30.4 18.4-15.1c2.4-2 5.7-2.4 8.5-1s4.6 4.1 4.6 7.2V464c0 17.7 14.3 32 32 32H432c17.7 0 32-14.3 32-32V192.7c0-3.1 1.8-5.9 4.6-7.2s6.1-.9 8.5 1l18.4 15.1 37.1 30.4c6.8 5.6 16.9 4.6 22.5-2.3l60.8-74.3c5.6-6.8 4.6-16.9-2.2-22.5l-37.1-30.4L497.4 37.7C480.2 23.7 458.7 16 436.6 16H416h-.3c-4.1 49.3-45.3 88-95.7 88s-91.6-38.7-95.7-88H224 203.4c-22.2 0-43.6 7.7-60.8 21.7zM416 0h20.6c25.9 0 50.9 8.9 70.9 25.3l79.2 64.8 37.1 30.4c13.7 11.2 15.7 31.4 4.5 45l-60.8 74.3c-11.2 13.7-31.4 15.7-45 4.5l-37.1-30.4-5.3-4.4V464c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V209.5l-5.3 4.4-37.2 30.4c-13.7 11.2-33.8 9.2-45-4.5L11.7 165.5c-11.2-13.7-9.2-33.8 4.5-45L53.3 90.1l79.2-64.8C152.5 8.9 177.6 0 203.4 0H224h8H408h8zM399.6 16H240.4c4 40.4 38.1 72 79.6 72s75.6-31.6 79.6-72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApparel);
export default __webpack_public_path__ + "static/media/apparel.ce2943f94f7e4cb2ba94767f5b2e8386.svg";
export { ForwardRef as ReactComponent };